"use strict";
exports.__esModule = true;
exports.reflect = exports.StellarMemoType = void 0;
exports.StellarMemoType = [
    "NO_MEMO",
    "MEMO_TEXT",
    "MEMO_ID",
    "MEMO_HASH",
    "MEMO_RETURN",
];
var reflect = function (_declare) { };
exports.reflect = reflect;
//# sourceMappingURL=types.js.map